import { useEffect, useState } from 'react';

const EVENT = 'pos-notification-badge-cleared';
export const notificationToken = item => JSON.stringify([item.id, item.kind || '', item.revision || '', item.at || item.updated_at || '', item.title || '']);

function read(key) {
  try {
    const data = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(data) ? data.filter(value => typeof value === 'string') : [];
  } catch { return []; }
}

// Only presentation state. Never delete notifications, post documents or mutate stock.
export default function useNotificationBadge(scope, kind, tokens = []) {
  const key = `pos_notification_cleared:v1:${scope}:${kind}`;
  const [saved, setSaved] = useState(() => ({ key, tokens: read(key) }));
  const [error, setError] = useState('');
  useEffect(() => {
    setSaved({ key, tokens: read(key) }); setError('');
    const sync = event => {
      if (event.key === key || event.key === null || event.detail === key) setSaved({ key, tokens: read(key) });
    };
    window.addEventListener('storage', sync);
    window.addEventListener(EVENT, sync);
    return () => { window.removeEventListener('storage', sync); window.removeEventListener(EVENT, sync); };
  }, [key]);
  const acknowledged = new Set(saved.key === key ? saved.tokens : read(key));
  const unread = [...new Set(tokens)].filter(token => !acknowledged.has(token)).length;
  const clear = () => {
    try {
      // Acknowledge exactly this snapshot: an arrival/revision during clear stays new.
      const next = [...new Set([...read(key), ...tokens])];
      localStorage.setItem(key, JSON.stringify(next));
      setSaved({ key, tokens: next }); setError('');
      window.dispatchEvent(new CustomEvent(EVENT, { detail: key }));
    } catch { setError('Belum berhasil menyimpan status bersih. Izinkan penyimpanan browser, lalu coba lagi.'); }
  };
  return { unread, clear, error };
}
